"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSpentAndInteractionsLoading = exports.TimeSpentAndInteractions = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlocksTimeSpent_1 = require("./BlocksTimeSpent");
var Interactions_1 = require("./Interactions");
var commonStyles = __importStar(require("../CommonStyles.css"));
var styles = __importStar(require("./TimeSpentAndInteractions.css"));
var TimeSpentAndInteractions = function (_a) {
    var blockViewDurations = _a.blockViewDurations, interactions = _a.interactions, noViewsYetComponent = _a.noViewsYetComponent;
    return (react_1.default.createElement("div", { className: "".concat(commonStyles.largeTabbedCard, " ").concat(styles.timeSpentAndInteractions) },
        react_1.default.createElement(kaleidoscope_1.Tabs, { className: commonStyles.tabs, initialIndex: 0 },
            react_1.default.createElement(kaleidoscope_1.TabList, { className: commonStyles.tabList, "aria-label": "Time spent and Interactions selector", isBordered: true },
                react_1.default.createElement(kaleidoscope_1.Tab, null, "Time spent"),
                react_1.default.createElement(kaleidoscope_1.Tab, null, "Outbound links")),
            react_1.default.createElement(kaleidoscope_1.TabPanels, { className: "".concat(commonStyles.tabPanels, " ").concat(styles.timeSpentAndInteractionsTabPanels) },
                react_1.default.createElement(kaleidoscope_1.TabPanel, null, noViewsYetComponent ? (renderNoViewsYet(noViewsYetComponent)) : (react_1.default.createElement(BlocksTimeSpent_1.BlocksTimeSpent, { blockViewDurations: blockViewDurations }))),
                react_1.default.createElement(kaleidoscope_1.TabPanel, null, noViewsYetComponent ? renderNoViewsYet(noViewsYetComponent) : react_1.default.createElement(Interactions_1.Interactions, { interactions: interactions }))))));
};
exports.TimeSpentAndInteractions = TimeSpentAndInteractions;
var TimeSpentAndInteractionsLoading = function () {
    return react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: styles.timeSpentAndInteractions });
};
exports.TimeSpentAndInteractionsLoading = TimeSpentAndInteractionsLoading;
function renderNoViewsYet(noViewsYetComponent) {
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", padding: "l" }, noViewsYetComponent));
}
